<template>
  <div class="file-table_body_ol" v-if="files.length">
    <div class="file-table_head">
      <span class="w-380">{{fileNameTitle}}</span>
      <span class="w-80 size">大小</span>
      <span class="w-60 status">状态</span>
    </div>
    <div class="project-upload-list">
      <template v-for="(file, index) in files">
        <div class="project-upload-list-item" v-if="!file.abort" :key="name + '_' + index">
          <span class="itemspan w-380 ellipsis-1" :title="handleName(file.name)">{{handleName(file.name)}}</span>
          <span class="itemspan w-80">{{ file.size | formatSizeFilter()}}</span>
          <span class="itemspan w-60">{{uploadStatus(file)}}</span>
          <span class="itemspan w-40">
            <a class="r2-icon-nav_close item-del" @click="remove(file)" v-if="+file.progress !== 100"></a>
            <img class="loadingimg" v-else-if="!file.uploadEnd" src="~@/assets/images/upload/loading.gif"/>
            <i class="r2-icon-action_check_circle_outline font-green" v-else-if="file.uploadEnd && file.succeed"></i>
            <i class="w-icon-qiangtixing font-red" v-else-if="file.uploadEnd && !file.succeed"></i>
          </span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
const uploadStatusMap = {
  uploading: '上传中',
  uploadSuccess: '上传成功',
  uploadFail: '上传失败'
}
export default {
  name: 'TaskList',
  props: {
    fileNameTitle: {
      type: String,
      default: '工程文件'
    },
    files: Array,
    name: String
  },
  methods: {
    // 文件名解析
    handleName (name) {
      if (name.indexOf('/') > -1) {
        let nameData = name.split('/')
        return nameData[nameData.length - 1]
      }
      return name
    },
    // 取消上传某一文件
    remove (item) {
      this.$emit('abort', item)
    },
    // 转换上传状态
    uploadStatus ({ progress, uploadEnd, succeed }) {
      const { uploading, uploadSuccess, uploadFail } = uploadStatusMap
      if (+progress !== 100) {
        return `${progress}%`
      } else if (!uploadEnd) {
        return uploading
      } else if (succeed) {
        return uploadSuccess
      } else {
        return uploadFail
      }
    }
  }
}
</script>

<style scoped>

</style>
